var protoAccess = {};

export { protoAccess as __exports };
//# sourceMappingURL=proto-access.js.map
